(function() {
    'use strict';

    // this should be replaced by xms-table at some point
    var ManualOvertimeCtrl = function ($scope, formFieldFactory) {

        var ctrl = this;

        $scope.overtimes             = initOvertimes();
        var initialDuration          = initDuration();

        $scope.totalHours            = initialDuration[0];
        $scope.totalMinutes          = initialDuration[1];
        var initialDurationInMinutes = initialDuration[2];

        ctrl.addOvertime = function() {
            $scope.overtimes.push({
                id: "",
                version: '',
                hours: 0,
                minutes: 0,
                payRate: 0.00,
                chargeRate: 0.00,
                durationTypeLookupVal: 5160
            });
        }

        ctrl.deleteOvertime = function(ct) {
            $scope.overtimes.splice(ct, 1);
            ctrl.updateStdHoursAndTotal();
        }

        ctrl.updateStdHoursAndTotal = function() {
            var totalDuration = 0;

            angular.forEach( $scope.overtimes, function(overtime){
                if(overtime.durationTypeLookupVal == 5160 && angular.isNumber(overtime.hours) && angular.isNumber(overtime.minutes)) {
                    totalDuration += (overtime.hours*60+overtime.minutes);
                }
            });

            var standardDuration = initialDurationInMinutes - totalDuration;

            $scope.overtimes[0].hours   = 0;
            $scope.overtimes[0].minutes = 0;

            if(standardDuration > 0) {
                $scope.overtimes[0].hours   = parseInt(standardDuration/60);
                $scope.overtimes[0].minutes = standardDuration % 60;

                totalDuration += standardDuration;
            }

            $scope.totalHours   = parseInt(totalDuration/60);
            $scope.totalMinutes = totalDuration % 60;

            // ctrl.popupForm['totalHours'].$dirty = true;
            formFieldFactory.triggerDependantFieldValidation(ctrl.popupForm['totalHours']);
            ctrl.popupForm['totalHours'].$validate();

            // ctrl.popupForm['totalMinutes'].$dirty = true;
            formFieldFactory.triggerDependantFieldValidation(ctrl.popupForm['totalMinutes']);
            ctrl.popupForm['totalMinutes'].$validate();
        }
    }
    ManualOvertimeCtrl.$inject = ['$scope', 'formFieldFactory'];
    angular.module('app').controller('ManualOvertimeCtrl',ManualOvertimeCtrl);

}());
